/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'display_message': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="#333" d="M512.048 1023.905H46.637A43.749 43.749 0 01.095 977.363v-465.41a511.952 511.952 0 11511.953 511.952zm-418.87-93.083h418.87a418.87 418.87 0 10-418.87-418.87z"/><path pid="1" _fill="#333" d="M698.212 418.87h-418.87a43.749 43.749 0 01-46.541-46.541 43.749 43.749 0 0146.541-46.541h418.87a43.749 43.749 0 0146.541 46.54 43.749 43.749 0 01-46.54 46.542zm0 186.165h-418.87a46.541 46.541 0 010-93.083h418.87a46.541 46.541 0 010 93.083zM512.048 791.199H279.342a46.541 46.541 0 010-93.082h232.706a46.541 46.541 0 010 93.082z"/>'
  }
})
